import { type JSXElement, Match, type ParentProps, Switch } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { LinkButton } from "@/designSystem/components/button"
import { Icon } from "@/designSystem/components/icon"
import { Text } from "@/designSystem/components/text"
import { useI18nContext } from "@/i18n/i18n-solid"
import { contentClass, headerClass, wrapperClass } from "./right-panel.css"

type Props = {
  closeHref: string
  header:
    | {
        type: "title"
        title: string
      }
    | {
        type: "back"
        href: string
      }
    | {
        type: "custom"
        content: JSXElement
      }
} & ParentProps

export function RightPanel(props: Props) {
  const { LL } = useI18nContext()

  return (
    <Box class={wrapperClass}>
      <div class={headerClass}>
        <Switch>
          <Match when={props.header.type === "title" && props.header}>
            {header => (
              <Box gap="8" flexDirection="row" alignItems="center">
                <Text fontSize="m" color="sand800" fontWeight="600">
                  {header().title}
                </Text>
              </Box>
            )}
          </Match>
          <Match when={props.header.type === "back" && props.header}>
            {header => (
              <LinkButton
                href={header().href}
                kind="surface"
                hue="amber"
                iconName="arrow-left"
              >
                {LL().common.back()}
              </LinkButton>
            )}
          </Match>
          <Match when={props.header.type === "custom" && props.header}>
            {header => header().content}
          </Match>
        </Switch>
        <LinkButton hue="sand" kind="ghost" href={props.closeHref}>
          <Icon name="x" size="18" />
        </LinkButton>
      </div>
      <div class={contentClass}>{props.children}</div>
    </Box>
  )
}
